export interface SortDefinition {
    name: string;
    dbName: string;
    direction?: "ascending" | "descending"; // default: ascending
}
